var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGdxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#17468F;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.2,399.5c-1.6-5.5-3.8-10.4-6.7-14.7c-2.9-4.3-6.4-7.9-10.5-10.9c-4.1-3-8.8-5.3-14.1-6.9 c-5.3-1.6-11.1-2.4-17.4-2.4c-11.9,0-22.3,3-31.3,8.9c-9,5.9-16,14.5-21,25.7s-7.5,25-7.5,41.2c0,16.2,2.5,30,7.4,41.4 c4.9,11.4,11.9,20,20.9,26c9,5.9,19.7,8.9,31.9,8.9c11.1,0,20.7-2,28.6-6c7.9-4,14-9.6,18.2-16.9c4.2-7.3,6.3-15.9,6.3-25.8l10,1.5 h-60v-37h97.4v29.3c0,20.5-4.3,38-13,52.7c-8.6,14.7-20.5,25.9-35.7,33.9c-15.2,7.9-32.5,11.9-52,11.9c-21.8,0-41-4.8-57.5-14.5 c-16.5-9.7-29.4-23.4-38.6-41.2c-9.2-17.8-13.8-39-13.8-63.6c0-18.9,2.7-35.7,8.2-50.5c5.5-14.8,13.2-27.4,23.1-37.7 c9.9-10.3,21.5-18.1,34.7-23.5c13.2-5.4,27.5-8.1,42.8-8.1c13.2,0,25.5,1.9,36.8,5.7c11.4,3.8,21.5,9.2,30.3,16.2 c8.8,7,16,15.2,21.6,24.8c5.6,9.6,9.2,20.1,10.8,31.6H276.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.2,557h-82.5V324.2h83.2c23.4,0,43.6,4.6,60.5,13.9c16.9,9.3,29.9,22.6,39,39.9 c9.1,17.3,13.7,38.1,13.7,62.3c0,24.2-4.6,45.1-13.7,62.5c-9.1,17.4-22.2,30.8-39.2,40.1C480.2,552.3,459.9,557,436.2,557z  M402.9,514.8h31.2c14.5,0,26.8-2.6,36.8-7.8c10-5.2,17.5-13.3,22.5-24.2c5-10.9,7.6-25.1,7.6-42.4c0-17.2-2.5-31.2-7.6-42.2 c-5-10.9-12.5-18.9-22.4-24.1c-9.9-5.2-22.2-7.7-36.7-7.7h-31.4V514.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M610.4,324.2l46.9,79.3h1.8l47.2-79.3h55.6l-71,116.4L763.5,557h-56.6l-47.7-79.4h-1.8L609.6,557h-56.4 l72.8-116.4l-71.5-116.4H610.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdxIcon);
export default __webpack_public_path__ + "static/media/gdx_icon.4ff932abe5e5503b7c7153d603ca0e07.svg";
export { ForwardRef as ReactComponent };